<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-10-28 10:31:17
 * @LastEditors: MoBai
 * @LastEditTime: 2022-07-21 10:30:03
-->
<template>
  <div class="container">
    <section class="leftContent">
      <section class="header">
        <el-button
          type="primary"
          @click="onShow('填写记录')"
          v-if="roleText == '专员' && user.commerStatus == 6"
          style="float: right"
          >填写记录</el-button
        >
        <span
          slot="footer"
          class="dialog-footer"
          style="float: right"
          v-if="roleText == '专员' && user.commerStatus == 2"
        >
          <el-button @click="onShow1('拒绝')">拒 绝</el-button>
          <el-button type="primary" @click="onShow1('接受')">接 受</el-button>
        </span>
        <div class="title">
          {{ user.commerTitle }}
          <span>{{ user.commerStatusStr }}</span>
        </div>
        <div class="information">
          <div>
            发起人：<span>{{ commerStatus(user.commerType) || '-' }}</span>
          </div>
          <div>
            创建时间：<span>{{ user.createTime || '-' }}</span>
          </div>
          <div>
            预约时间：<span>{{ user.startTime }} - {{ user.endTime }}</span>
          </div>
        </div>
        <div class="information">
          <div>
            走访企业：<span>{{ user.entName || '-' }}</span>
          </div>
          <div>
            联系人：<span>{{ user.contactPerson || '-' }}</span>
          </div>
        </div>
        <div class="information">
          <div>
            联系电话：<span>{{ user.contactPhone || '-' }}</span>
          </div>
          <div>
            专员：<span>{{ user.name || '-' }}</span>
          </div>
        </div>
        <div class="information">
          <div class="specialFlex">
            描述：<span>{{ user.notes || '-' }}</span>
          </div>
        </div>
      </section>
      <section
        class="content"
        v-if="user.commerStatus == 8 || user.commerStatus == 7"
      >
        <div class="title">企业走访信息</div>
        <div class="text">
          <p>企业走访信息：</p>
          {{ user.remark }}
          <img
            style="display: block; margin: 0 auto"
            v-if="!user.remark"
            src="@/assets/imagess/es-sfss.png"
            alt=""
          />
        </div>
        <div class="ImgContent">
          <div v-for="item in user.fileList" :key="item.id">
            <img @click="onImg(item.uploadUrl)" :src="item.uploadUrl" alt="" />
          </div>
        </div>
      </section>
      <section class="footer">
        <div class="title">企业走访记录</div>
        <div class="block">
          <el-timeline>
            <el-timeline-item
              timestamp=""
              placement="top"
              v-for="(item, index) in process"
              :key="index"
            >
              <el-card>
                <h4>{{ item.commerDescribe }}</h4>
                <p>{{ item.name }} {{ item.createTime }}</p>
                <p
                  v-if="
                    item.commerDescribe != '企业已评价' &&
                    item.commerDescribe != '等待企业处理' &&
                    item.commerDescribe != '等待企业评价' &&
                    item.commerDescribe != '企业发起邀请' &&
                    item.commerDescribe != '专员发起邀请' &&
                    item.commerDescribe != '等待专员处理' &&
                    item.commerDescribe != '等待专员上传记录' &&
                    item.commerDescribe != '企业修改了走访信息'
                  "
                >
                  备注：{{ item.remark || '-' }}
                </p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </section>
    </section>
    <section class="rightContent" v-if="user.commerStatus == 8">
      <div class="title">企业评价</div>
      <el-rate
        v-model="user.starLevel"
        show-text
        :texts="text"
        text-color="rgba(153, 153, 153, 100)"
        disabled
      >
      </el-rate>
      <el-divider></el-divider>
      <div class="text">{{ user.remarks }}</div>
    </section>
    <el-dialog
      title="填写记录"
      :visible.sync="dialogVisible"
      width="55%"
      @closed="handleClose"
    >
      <div>
        <el-form
          :model="message"
          ref="message"
          label-width="100px"
          label-position="left"
          :rules="rules"
        >
          <el-form-item label="走访记录：" prop="remark">
            <el-input
              type="textarea"
              v-model="message.remark"
              placeholder="请输入"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="">
            <el-upload
              class="upload-demo"
              list-type="picture-card"
              :headers="uploadHeader"
              :action="addEntData"
              :limit="5"
              :on-preview="handlePreviewImg"
              :file-list="fileListImg"
              :on-exceed="handleExceedImg"
              :on-remove="handleRemoveImg"
              :before-upload="beforeAvatarUploadImg"
              :on-success="docSuccess"
              accept=".jpg, .png, .jpeg"
              multiple
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <Debounce :time="5000" :isDebounce="3">
          <button
            type="button"
            class="el-button el-button--primary el-button--medium"
            @click="sendMovenSMS('message')"
          >
            <span>确 定</span>
          </button>
        </Debounce>
        <!-- <el-button type="primary" @click="sendMovenSMS('message')"
          >确 定</el-button
        > -->
      </span>
    </el-dialog>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible1"
      width="35%"
      @closed="handleClose1"
    >
      <div>
        <el-form
          :model="message1"
          ref="message1"
          label-width="100px"
          label-position="left"
        >
          <el-form-item label="修改时间：" v-if="title == '拒绝'">
            <el-col :span="10" style="margin-right: 10px">
              <el-date-picker
                style="width: 100%"
                type="date"
                placeholder="选择日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                v-model="message1.date"
              ></el-date-picker>
            </el-col>
            <el-col :span="13">
              <el-time-picker
                style="width: 100%"
                is-range
                v-model="message1.time"
                range-separator="-"
                start-placeholder="起始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
                format="HH:mm"
                value-format="HH:mm"
              >
              </el-time-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input
              type="textarea"
              v-model="message1.remark"
              placeholder="请输入"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose1">取 消</el-button>
        <Debounce :time="5000" :isDebounce="3">
          <button
            type="button"
            class="el-button el-button--primary el-button--medium"
            @click="sendMovenSMS1('message1')"
          >
            <span>确 定</span>
          </button>
        </Debounce>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="showImg" width="30%" class="showImg">
      <img width="100%" :src="exhibitImg" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import {
  getDetailById,
  getProcessById,
  addEntData,
  dealVisitRecord
} from '@api/commissionerManagement/visit'
import { isHttp, getToken, notEmpty } from '@utils'
export default {
  name: 'Live',
  data() {
    return {
      title: '',
      addEntData,
      dialogVisible: false,
      text: ['非常不满意', '不满意', '一般', '满意', '非常满意'],
      message: { remark: '' },
      message1: {
        date: '',
        time: '',
        remark: ''
      },
      rules: {
        remark: [notEmpty('走访记录')]
      },
      uploadHeader: {
        Authorization: 'Bearer ' + getToken()
      },
      fileListImg: [],
      user: {},
      process: [],
      status: '',
      roleText: '',
      dialogVisible1: false,
      showImg: false,
      exhibitImg: ''
    }
  },
  watch: {},
  computed: {
    commerStatus() {
      return (number) => {
        let val
        switch (number) {
          case 1:
            val = '企业'
            break
          case 2:
            val = '专员'
            break
        }
        return val
      }
    }
  },
  created() {
    this.getDetailById()
    this.getProcessById()
    this.roleText = this.$store.state.user.userInfo.roleText
  },
  mounted() {},
  methods: {
    // 获取走访详情
    getDetailById() {
      getDetailById({ id: this.$route.query.id }).then((res) => {
        if (res.data.code == '0000') {
          this.user = res.data.data
          this.user.fileList = this.user.fileList || []
        }
      })
    },
    // 获取走访记录
    getProcessById() {
      getProcessById({ id: this.$route.query.id }).then((res) => {
        if (res.data.code == '0000') {
          this.process = res.data.data || []
        }
      })
    },
    /** 关闭联系企业清空弹窗 */
    handleClose() {
      this.dialogVisible = false
      this.$refs['message'].resetFields()
    },
    handleClose1() {
      this.dialogVisible1 = false
      this.message1.remark = ''
      this.message1.time = ''
      this.message1.date = ''
      this.$refs['message1'].resetFields()
    },
    /** 打开弹性 */
    onShow(name) {
      this.status = 2
      this.dialogVisible = true
    },
    onShow1(name) {
      this.title = name
      this.status = name == '拒绝' ? 0 : 1
      this.dialogVisible1 = true
    },
    beforeAvatarUploadImg(file) {},
    onImg(url) {
      this.exhibitImg = url
      this.showImg = true
    },
    handlePreviewImg(file) {
      this.exhibitImg = file.url
      this.showImg = true
    },
    handleExceedImg(files, fileList) {
      this.$message.warning('当前限制选择 5 个图片')
    },
    handleRemoveImg(file, fileList) {
      const index = this.fileListImg.findIndex((item) => {
        return item.response.data.id == file.id
      })
      this.fileListImg.splice(index, 1)
    },
    docSuccess(response, file, fileList) {
      if (response.code == '0000') {
        // console.log(file)
        /* this.fileListImg.push({
          id: response.data.id,
          name: response.data.fileName,
          url: response.data.uploadUrl
        }) */
        // this.ruleForm.coverUrl = response.data.ossUrl
        // this.$refs.imageId.clearValidate()
        this.fileListImg = fileList // 为什么直接赋值？解决上传来回抖动问题
        console.log(this.fileListImg)
      }
    },
    sendMovenSMS(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const fileListImg = this.fileListImg.length
            ? this.fileListImg
                .map((item) => {
                  return item.response.data.id
                })
                .join(',')
            : ''
          let data = {
            ...this.message,
            status: this.status,
            id: this.$route.query.id,
            fileId: fileListImg
          }
          dealVisitRecord(data).then((res) => {
            if (res.data.code == '0000') {
              this.$message.success(res.data.msg)
              this.handleClose()
              this.fileListImg = []
              this.dialogVisible = false
              this.getDetailById()
              this.getProcessById()
            } else {
              this.$message.error(res.data.msg)
              this.dialogVisible = false
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    sendMovenSMS1(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            status: this.status,
            id: this.$route.query.id,
            version: this.user.version
          }
          data.remark =
            this.title == '拒绝'
              ? '可预约时间：' +
                this.message1.date +
                ' ' +
                (this.message1.time[0] ? this.message1.time[0] : '') +
                '-' +
                (this.message1.time[1] ? this.message1.time[1] : '') +
                ' ' +
                this.message1.remark
              : this.message1.remark
          dealVisitRecord(data).then((res) => {
            if (res.data.code == '0000' && res.data.data > 0) {
              this.$message.success(res.data.msg)
              this.handleClose1()
              this.getDetailById()
              this.getProcessById()
            } else {
              if (res.data.code === '0004') {
                this.$alert(res.data.msg, '提示', {
                  confirmButtonText: '确定',
                  showClose: false,
                  type: 'warning'
                }).then(() => {
                  this.$router.push({ name: 'visitList' })
                })
              } else {
                let msg =
                  res.data.data > 0 ? res.data.msg : '信息已被修改,请重新确认'
                this.$alert(msg, '提示', {
                  confirmButtonText: '确定',
                  type: 'warning'
                }).then(() => {
                  this.handleClose1()
                  this.getDetailById()
                  this.getProcessById()
                })
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style>
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
}
.hide .el-upload--picture-card {
  display: none;
}
</style>
<style lang="scss" scoped>
.showImg {
  /deep/ .el-dialog__header {
    border-bottom: none !important;
  }
}
/deep/ .el-dialog__wrapper {
  .el-dialog__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .el-dialog__body {
    // height: 400px;
    overflow: auto;
    padding: 30px 60px 20px;
    font-size: 16px;
    .el-textarea__inner {
      height: 100px;
    }
  }
  .el-upload--picture-card {
    width: 120px;
    height: 120px;
  }
  .el-upload-list__item {
    width: 120px;
    height: 120px;
  }
  .el-dialog__footer {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
}
.container {
  width: 100%;
  overflow-y: auto;
  display: flex;
  justify-content: space-between;
  & > .leftContent {
    width: 100%;
    > .header {
      padding: 24px;
      background: white;
      > .title {
        color: rgba(0, 0, 0, 0.85);
        font-size: 18px;
        font-weight: 600;
        > span {
          color: #1890ff;
          font-size: 12px;
          margin-left: 30px;
          display: inline-block;
          border-radius: 2px;
          background-color: rgba(47, 123, 251, 0.05);
        }
      }
      & > .information {
        margin-top: 16px;
        display: flex;
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
        > div {
          width: 33.3%;
          span {
            color: rgba(0, 0, 0, 0.5);
          }
        }
        .specialFlex {
          flex: 0.9;
        }
      }
    }
    > .content {
      margin-top: 16px;
      background: white;
      > .title {
        padding: 16px 21px;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
      }
      > .text {
        padding: 0 21px;
        font-size: 14px;
        line-height: 25px;
        color: rgba(0, 0, 0, 0.5);
        > p {
          color: rgba(0, 0, 0, 0.85);
        }
      }
      > .ImgContent {
        padding: 0 21px 30px;
        display: flex;
        margin-top: 30px;
        > div {
          width: 167px;
          height: 200px;
          line-height: 200px;
          margin-right: 20px;
          > img {
            width: 167px;
            height: 167px;
            vertical-align: middle;
            width: inherit;
            cursor: pointer;
            border-radius: 3px;
          }
        }
      }
    }
    > .footer {
      margin-top: 16px;
      background: white;
      > .title {
        padding: 16px 21px;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
      }
      > .block {
        width: 60%;
        margin-top: 30px;
        /deep/ .el-card {
          border: none;
          box-shadow: none;
          background-color: rgba(0, 0, 0, 0.02);
        }
        /deep/ .el-timeline-item__node {
          background-color: rgba(24, 144, 255, 1);
        }
        /deep/ .el-timeline-item__tail {
          height: 88%;
          margin-top: 15px;
          border-left: 2px solid rgba(24, 144, 255, 1);
        }
      }
    }
  }
  & > .rightContent {
    margin-left: 20px;
    width: 215px;
    padding: 17px;
    background: white;
    > .title {
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 30px;
    }
    > .text {
      color: rgba(102, 102, 102, 100);
      font-size: 14px;
    }
  }
}
</style>
